import { INSERT_AND_UPDATE_CAR_PASSESS_ACTION_TYPE, GET_CAR_PASSESS_DETAILS_ACTION_TYPE } from "../../../../../utils/constants";


const initialState = [];

function carPassessReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case INSERT_AND_UPDATE_CAR_PASSESS_ACTION_TYPE:
            return [...state, payload];
        case GET_CAR_PASSESS_DETAILS_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default carPassessReducer;